import { monitor } from '..';
import { PlatformPerfMetric } from './enums';
import { appTimingUtil } from './utils';

const createPlatformTracker = () => {
  let initedDuration = 0;
  let renderedDuration = 0;

  return {
    // track when app starts to init
    trackAppInit: () => {
      if (initedDuration) return;
      initedDuration = appTimingUtil.getAppAliveDuration();
      monitor.sendDuration({
        name: PlatformPerfMetric.AppInit,
        duration: initedDuration,
      });
    },
    // track when app component first did mount
    trackAppRendered: () => {
      if (renderedDuration) return;
      renderedDuration = appTimingUtil.getAppAliveDuration();
      monitor.sendDuration({
        name: PlatformPerfMetric.AppRendered,
        duration: renderedDuration,
        data: {
          duration_from_init: Math.max(
            1,
            Math.round(renderedDuration - initedDuration)
          ),
        },
      });
    },
  };
};

export const platformTracker = createPlatformTracker();
